<script setup>
const props = defineProps({ blok: Object, theme: String })

const BothClasses = computed(() => {
  switch (props.theme) {
    case 'yellow':
      return 'border-yellow-500 bg-yellow-500'
    case 'blue':
      return 'border-blue-500 bg-blue-500'
    case 'green':
      return 'border-green-500 bg-green-500'
    default:
      return 'border-secondary-red-100 bg-secondary-red-100'
  }
})

const bgColorClasses = computed(() => {
  switch (props.theme) {
    case 'yellow':
      return 'bg-yellow-500 group-hover/card:bg-yellow-500/25'
    case 'blue':
      return 'bg-blue-500 group-hover/card:bg-blue-500/25'
    case 'green':
      return 'bg-green-500 group-hover/card:bg-green-500/25'
    default:
      return 'bg-secondary-red-100 group-hover/card:bg-secondary-red-100/25'
  }
})

const modalActive = ref(false)
function openModal() {
  modalActive.value = true
}
function closeModal() {
  modalActive.value = false
}
</script>

<template>
  <div class="group/card relative max-w-4xl w-full flex cursor-pointer items-center justify-center" @click="openModal">
    <div
      :class="BothClasses"
      class="absolute inset-0 z-10 m-auto h-[60px] w-[60px] flex scale-100 items-center border-2 rounded-full shadow-custom-xl transition duration-200 ease-out lg:h-[90px] lg:w-[90px] md:h-[80px] md:w-[80px] sm:h-[70px] sm:w-[70px] group-hover/card:scale-110"
    >
      <div :class="bgColorClasses" class="absolute inset-0 z-0 m-auto h-full w-full scale-100 animate-ping border-0 rounded-full group-hover/card:scale-125 group-hover/card:animate-none" />
      <svg class="relative m-auto h-7 w-7 text-white md:h-8 md:w-8 xl:h-10 xl:w-10" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="currentColor" d="M8 19V5l11 7l-11 7Z" /></svg>
    </div>
    <nuxt-img
      :alt="blok.cover.alt"
      class="z-0 rounded-2xl object-cover sm:rounded-xl"
      :src="`${blok.cover.filename}/m/896x505/filters:quality(80)`"
    />
  </div>
  <UIModalVideo :video-url="blok.media.filename ? blok.media.filename : blok.video_url" :modal-active="modalActive" @close="closeModal" />
</template>
